<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router';
import { computed } from 'vue';

const route = useRoute();
const path = computed(() => route.path);

const tabs: Array<{ to: string; label: string }> = [
  { to: '/account/settings', label: 'Settings' },
  { to: '/account/profile', label: 'Profile' },
  { to: '/account/organization', label: 'Organization' },
  { to: '/invitations', label: 'User Invitations' },
];

function isActive(to: string): boolean {
  return path.value.startsWith(to);
}
</script>

<template>
  <nav class="account-sub-nav">
    <ul class="account-sub-nav__list">
      <li v-for="tab in tabs" :key="tab.to">
        <RouterLink :to="tab.to" :class="['account-sub-nav__link', { 'is-active': isActive(tab.to) }]">
          {{ tab.label }}
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>

<style scoped>
.account-sub-nav {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.account-sub-nav__list {
  display: flex;
  gap: 1.5rem;
  list-style: none;
  margin: 0 auto;
  padding: 0.5rem 1.5rem;
  max-width: 60rem;
}
.account-sub-nav__link {
  color: #4b5563;
  text-decoration: none;
  font-weight: 500;
}
.account-sub-nav__link.is-active {
  color: #2563eb;
  text-decoration: underline;
}
</style>
